import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import NewToggleCTALinkButton from 'components/essentials/NewToggleCTALinkButton';
const TextContentButtonGroup = t0 => {
  const $ = _c(10);
  const {
    mainButton,
    subButton,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("flex !flex-col gap-4 w-fit", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== mainButton) {
    t2 = mainButton && <NewToggleCTALinkButton {...mainButton} />;
    $[2] = mainButton;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subButton) {
    t3 = subButton && <NewToggleCTALinkButton {...subButton} />;
    $[4] = subButton;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default TextContentButtonGroup;